<script setup lang="ts">
import { computed, onBeforeUnmount, watch } from 'vue'
import { useMediaQuery } from '@vueuse/core'
import { usePlatform } from '@/composables/usePlatform'
import { registerOverlayBackHandler } from '@/composables/useNativeUI'

defineOptions({ inheritAttrs: false })
const props = withDefaults(defineProps<{ title?: string; width?: string | number; busy?: boolean; closeOnClickModal?: boolean }>(), {
  width: 'min(680px, calc(100vw - 32px))', closeOnClickModal: true, busy: false,
})
const open = defineModel<boolean>({ required: true })
const { isNative } = usePlatform()
const isMobile = useMediaQuery('(max-width: 767px)')
const isSheet = computed(() => isNative || isMobile.value)
let removeBackHandler: (() => void) | undefined
watch(open, visible => {
  removeBackHandler?.()
  removeBackHandler = undefined
  if (isNative && visible) removeBackHandler = registerOverlayBackHandler(() => { if (!props.busy) open.value = false })
}, { immediate: true })
onBeforeUnmount(() => removeBackHandler?.())
</script>

<template>
  <el-drawer v-if="isSheet" v-model="open" v-bind="$attrs" direction="btt" size="auto" :title="title" class="app-sheet" :class="{ 'app-sheet--footer': !!$slots.footer }" :close-on-click-modal="closeOnClickModal && !busy" :close-on-press-escape="!busy" :show-close="!busy">
    <template v-if="$slots.header" #header><slot name="header" /></template><slot /><template v-if="$slots.footer" #footer><slot name="footer" /></template>
  </el-drawer>
  <el-dialog v-else v-model="open" v-bind="$attrs" :title="title" :width="width" align-center class="app-dialog" :close-on-click-modal="closeOnClickModal && !busy" :close-on-press-escape="!busy" :show-close="!busy">
    <template v-if="$slots.header" #header><slot name="header" /></template><slot /><template v-if="$slots.footer" #footer><slot name="footer" /></template>
  </el-dialog>
</template>
